<template lang="pug">
div
    v-navigation-drawer(
        v-model="drawer"
        app
        color="drawer"
        dark
    )
        v-list
          v-list-item
            img(:src="require('@/assets/img/logo.svg')")
            //- v-list-item-subtitle {{ $store.state.user.current.username }}

        v-divider
        v-list
          v-list-item(:to="{name: $ROUTER_NAMES.TRAINING_CHAPTER_CATEGORIES}")
            v-list-item-icon
              v-icon mdi-account-group
            v-list-item-content
              v-list-item-title Training Chapters
          v-list-item(:to="{name: $ROUTER_NAMES.TRAININGS}")
            v-list-item-icon
              v-icon mdi-account-group
            v-list-item-content
              v-list-item-title Training Subchapters
          v-list-item(:to="{name: $ROUTER_NAMES.EXAMS}")
            v-list-item-icon
              v-icon mdi-account-group
            v-list-item-content
              v-list-item-title Exams
          v-list-item(:to="{name: $ROUTER_NAMES.USERS}")
            v-list-item-icon
              v-icon mdi-account-group
            v-list-item-content
              v-list-item-title Users
          v-list-item(:to="{name: $ROUTER_NAMES.PAYMENTS}")
            v-list-item-icon
              v-icon mdi-account-group
            v-list-item-content
              v-list-item-title Payments


    v-app-bar(app color='primary' dark)
        v-btn(icon @click="drawer = !drawer")
          v-icon $vuetify.icons.hamburger
        portal-target(name="toolbar")
        v-spacer
        user-menu

    v-content
        router-view
</template>

<script>
import auth from "@/services/ExerciseInitAuth"
export default {
  name: "ExerciseLayout",
  data: () => ({
    drawer: false
  }),
  provide() {
    return {
      logout: this.logout,
    }
  },
  created() {
    this.$store.dispatch('settings/fetch');
  },
  methods: {
    async logout() {
      auth.logout();
      this.redirectToAuth();
    },
    redirectToAuth() {
      this.$router.push({name: this.$ROUTER_NAMES.LOGIN_EXERCISE})
    }
  },
  components: {
    UserMenu: () => import("@/components/widget/UserSettings.vue")
  }
};
</script>

<style lang="scss" scoped>
.menu-item::v-deep {
  text-transform: capitalize;
}
</style>
